import React from "react";
import ReactDOM from "react-dom";
import MainLayout from './Layout/MainLayout';

ReactDOM.render(<MainLayout />, document.getElementById("root"));